import React, { useState } from "react";
import "../styles/landingPage.css";
import "../styles/extraPages.css";
import Navbar from "./navbar";

export default function ContactPage() {
    const [form, setForm] = useState({ name: "", email: "", message: "" });
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);
    };

    return (
        <div className="landingPageContainer">
            <div className="ambient-blob blob-1"></div>
            <div className="ambient-blob blob-2"></div>

            <Navbar />

            <div className="extraPage-container">
                <div className="extraPage-hero">
                    <h1 className="extraPage-title">
                        Get in <span className="highlight-text">Touch</span>
                    </h1>
                    <p className="extraPage-subtitle">
                        Have questions or feedback? We'd love to hear from you.
                    </p>
                </div>

                <div className="contact-form-wrapper">
                    {submitted ? (
                        <div className="contact-success">
                            <div className="contact-success-icon">✅</div>
                            <h3>Message Sent!</h3>
                            <p>Thanks for reaching out. We'll get back to you shortly.</p>
                            <button
                                className="qm-nav-btn qm-nav-btn--ghost"
                                style={{ marginTop: "1.5rem" }}
                                onClick={() => setSubmitted(false)}
                            >
                                Send Another
                            </button>
                        </div>
                    ) : (
                        <form className="contact-form" onSubmit={handleSubmit}>
                            <div className="contact-form-group">
                                <label htmlFor="name">Your Name</label>
                                <input
                                    id="name"
                                    type="text"
                                    name="name"
                                    placeholder="Ritesh Mishra"
                                    value={form.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="contact-form-group">
                                <label htmlFor="email">Email Address</label>
                                <input
                                    id="email"
                                    type="email"
                                    name="email"
                                    placeholder="hello@quickmeet.com"
                                    value={form.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="contact-form-group">
                                <label htmlFor="message">Message</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    rows={5}
                                    placeholder="Tell us what's on your mind..."
                                    value={form.message}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <button type="submit" className="ctaBtn" style={{ width: "100%" }}>
                                Send Message
                            </button>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}
